import { FloatingActionBar, Button } from "@chef/components";
import { intl } from "./FloatingBar.Intl";

interface FloatingBarProps {
  onContinue: () => void;
  disabled?: boolean;
  id?: string;
  isLoading?: boolean;
}

export const FloatingBar = ({
  onContinue,
  disabled,
  id,
  isLoading,
}: FloatingBarProps) => {
  return (
    <FloatingActionBar
      as="div"
      isFullWidth={false}
      grid={false}
      innerClassName="flex-row flex justify-between lg:justify-end lg:gap-6"
      className="sticky"
    >
      <div className="lg:text-end">
        <p className="text-discount">
          <strong>{intl.YOU_DECIDE}</strong>
        </p>
        <p className="text-sm">{intl.PAUSE_OR_STOP}</p>
      </div>
      <Button
        primary
        onClick={onContinue}
        className="px-5 md:px-10 lg:px-20"
        disabled={disabled}
        loading={isLoading}
        id={id}
      >
        {intl.GO_FORWARD}
      </Button>
    </FloatingActionBar>
  );
};
